// @ts-nocheck

export type AdminStoriesListStatus =
  typeof AdminStoriesListStatus[keyof typeof AdminStoriesListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminStoriesListStatus = {
  COMPLETE: "COMPLETE",
  ERROR: "ERROR",
  GENERATING: "GENERATING",
  PENDING: "PENDING",
} as const;
